const certifiedCourseData = [
  // The Certified Business Consultant Data
  {
    id: "business-consultant",
    applicationLink: "",
    backgroundImage:
      "https://images.unsplash.com/photo-1758873272345-40f377c21e7f?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    blurHash: "LbMH0^xu?v-;~pM{R*js%NxtIVRj",
    title: " Certified Business Consultant",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Business Consultancy",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business & Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",
    showonhomepage: true,
    miniblabforhomepage:
      "Empower organisations with expert strategies! Master the skills to transform businesses & drive success in today’s competitive landscape. Start your consulting journey now!",
    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `Welcome to The Postgraduate Diploma in Business Consultancy Programme which offers a unique opportunity to earn the esteemed Certified Business Consultant designation.

The Postgraduate Diploma in Business Consultancy equips professionals with advanced expertise in strategic consulting, financial analysis, marketing, & global business dynamics. 

Designed for career progression, the programme fosters critical thinking, research-based decision-making, & innovative problem-solving in complex business environments. 

Combining academic rigour with practical application, this programme prepares graduates to become thought leaders in business consultancy & management.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌍",
          title: "Global Recognised Certification",
          description:
            "Earn a globally recognised certification to boost your professional credentials.",
        },
        {
          icon: "📚",
          title: "Flexible Learning",
          description:
            "Participate in 100 hours of live teaching & self-paced learning for maximum flexibility.",
        },
        {
          icon: "🤝",
          title: "Networking Opportunities",
          description:
            "Connect with a global cohort of professionals & industry experts to expand your network.",
        },
        {
          icon: "🛠️",
          title: "Practical Projects",
          description:
            "Apply skills to real-world scenarios through case studies, workshops, & a capstone project.",
        },
        {
          icon: "🏆",
          title: "Career Advancement",
          description:
            "Gain exemptions/credits for diploma or degree programmes with Mila University.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Foundation",
        title: "Foundation Level: Theoretical Foundations of Career Coaching",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Introduction to Career Coaching Principles & Practices",
            credits: 5,
            description: "--",
          },
          {
            title: "Communication & Relationship-Building Strategies",
            credits: 5,
            description: "--",
          },
          {
            title: "Goal Setting & Career Planning Frameworks",
            credits: 5,
            description: "--",
          },
          {
            title: "Reflective Practice in Coaching",
            credits: 5,
            description: "--",
          },
        ],
      },
      {
        stage: "Advanced",
        title: "Advanced Level: Application & Ethics",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Advanced Coaching Methodologies & Techniques",
            credits: 5,
            description: "--",
          },
          {
            title:
              "Use of Psychometric & Assessment Tools in Career Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Coaching Ethics & Professional Standards",
            credits: 10,
            description: "--",
          },
          {
            title: "Research Methods for Career Coaching Practices",
            credits: 10,
            description: "--",
          },
        ],
      },
      {
        stage: "Masters",
        title: "Master’s Level: Leadership & Strategic Coaching",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Leadership & Executive Coaching Strategies",
            credits: 15,
            description: "--",
          },
          {
            title: "Entrepreneurial Coaching & Business Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Advanced Organisational Behaviour & Change Management",
            credits: 5,
            description: "--",
          },
          {
            title: "Capstone Project: Research-Based Coaching Intervention",
            credits: 5,
            description: "--",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Business Consultancy",
        description: [
          "Explore the theoretical foundations of consultancy, including client management & consultancy lifecycle.",
        ],
      },
      {
        title: "Advanced Strategic Management",
        description: [
          "Apply strategic frameworks to solve complex organisational challenges.",
          "Incorporate technology & innovation into consulting practices.",
        ],
      },
      {
        title: "Financial Analysis for Consultants",
        description: [
          "Analyse financial statements, forecasting models, & risk management strategies to provide actionable insights.",
        ],
      },
      {
        title: "Marketing & Branding for Consultants",
        description: [
          "Develop advanced marketing plans & leverage digital tools for branding & client acquisition.",
        ],
      },
      {
        title: "Ethics & Legal Compliance in Consultancy",
        description: [
          "Examine legal frameworks, client confidentiality, & ethical dilemmas in consultancy.",
        ],
      },
      {
        title: "Advanced Data Analytics & Technology",
        description: [
          "Master data-driven decision-making using advanced tools & methodologies.",
        ],
      },
      {
        title: "Training & Mentorship in Consultancy",
        description: [
          "Design & deliver training programmes, applying adult learning principles & mentoring techniques.",
        ],
      },
      {
        title: "Global Business & Entrepreneurship",
        description: [
          "Address the complexities of globalisation, international trade, & cross-cultural management.",
          "Learn business ideation & venture creation strategies.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Conduct research to solve a real-world business problem, demonstrating integration of knowledge across modules.",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📊",
        title: "Business Consultant:",
        description:
          "Provide expert advice to businesses to improve performance & efficiency.",
      },
      {
        icon: "💵",
        title: "Financial Analyst:",
        description:
          "Analyse financial data & provide insights to support strategic decision-making.",
      },
      {
        icon: "📈",
        title: "Strategic Manager:",
        description:
          "Develop & implement strategies to achieve long-term organisational goals.",
      },
      {
        icon: "📢",
        title: "Marketing Consultant:",
        description:
          "Design & execute marketing strategies to enhance brand presence & client acquisition.",
      },
      {
        icon: "🎓",
        title: "Corporate Trainer:",
        description:
          "Deliver professional development programmes & workshops to enhance employee skills.",
      },
      {
        icon: "🌍",
        title: "International Business Advisor:",
        description:
          "Provide guidance on global business practices, cross-border trade, & market entry strategies.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/score-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/certificate-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/attend-class-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r11.jpeg",
  },

  // The Certified Executive Career Coach Data
  {
    id: "executive-career-coach",
    applicationLink: "",
    backgroundImage:
      "/Image Assets/indemandprograms/Certified_Executive_Career_Coach_image.jpg",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: " Certified Executive Career Coach",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Executive Career Coaching",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business & Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",
    showonhomepage: true,
    miniblabforhomepage:
      "Inspire success, transform lives! Gain the expertise to guide executives toward achieving their career aspirations with confidence & clarity. Begin your coaching journey today!",
    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `Elevate your career with the Postgraduate Diploma in Executive Career Coaching. This programme, offered by ESBD, awards the distinguished Certified Executive Career Coach designation, equipping you to excel as a leader in career coaching & professional development.

The 26 – 32 week immersive Postgraduate Diploma in Executive Career Coaching develops advanced expertise in career coaching, combining rigorous theoretical frameworks with practical application.

Participants will master coaching methodologies, ethical practices, & innovative strategies to support professionals in achieving career success.

Through research-led learning, critical analysis, & leadership development, this programme equips graduates to become transformative leaders in career coaching, capable of driving organisational & individual growth in diverse professional contexts.

With a focus on remote learning & practical application, the programme caters to both seasoned professionals & newcomers to the field, ensuring personal & professional growth.

This Programme is designed to provide participants with an in-depth understanding & advanced expertise of career coaching principles & practices. Delivered across three progressive

levels—Foundation, Advanced, & Master’s—the programme integrates theory & practical exercises to develop your expertise in coaching, leadership, & career development.

This comprehensive course is ideal for those passionate about guiding others toward achieving career goals & professional fulfilment.

Learners will be awarded the prestigious Certified Executive Career Coach designation upon successfully completing the Postgraduate Diploma in Executive Career Coaching.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌟",
          title: "Expert-Led Webinars",
          description:
            "Engage in two webinar series featuring renowned guest lecturers, offering insights into key career coaching themes.",
        },
        {
          icon: "💬",
          title: "Interactive Online Tutorials",
          description:
            "Access dedicated online tutorials with programme leaders & industry experts for personalised support.",
        },
        {
          icon: "📝",
          title: "Practical Engagement",
          description:
            "Apply knowledge through assignments, case studies, forum discussions, & a capstone project.",
        },
        {
          icon: "📜",
          title: "Certified Recognition",
          description:
            "Earn the prestigious Certified Executive Career Coach title upon completion.",
        },
        {
          icon: "🌐",
          title: "Networking Opportunities",
          description:
            "Collaborate with peers & mentors to build a global professional network.",
        },
        {
          icon: "🎓",
          title: "Eligible for Summer School Programme",
          description:
            "Participants can enhance their learning experience through an optional Summer School Programme.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: true,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Foundation",
        title: "Foundation Level: Theoretical Foundations of Career Coaching",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Introduction to Career Coaching Principles & Practices",
            credits: 5,
            description: "--",
          },
          {
            title: "Communication & Relationship-Building Strategies",
            credits: 5,
            description: "--",
          },
          {
            title: "Goal Setting & Career Planning Frameworks",
            credits: 5,
            description: "--",
          },
          {
            title: "Reflective Practice in Coaching",
            credits: 5,
            description: "--",
          },
        ],
      },
      {
        stage: "Advanced",
        title: "Advanced Level: Application & Ethics",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Advanced Coaching Methodologies & Techniques",
            credits: 5,
            description: "--",
          },
          {
            title:
              "Use of Psychometric & Assessment Tools in Career Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Coaching Ethics & Professional Standards",
            credits: 10,
            description: "--",
          },
          {
            title: "Research Methods for Career Coaching Practices",
            credits: 10,
            description: "--",
          },
        ],
      },
      {
        stage: "Masters",
        title: "Master’s Level: Leadership & Strategic Coaching",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Leadership & Executive Coaching Strategies",
            credits: 15,
            description: "--",
          },
          {
            title: "Entrepreneurial Coaching & Business Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Advanced Organisational Behaviour & Change Management",
            credits: 5,
            description: "--",
          },
          {
            title: "Capstone Project: Research-Based Coaching Intervention",
            credits: 5,
            description: "--",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Leadership & Gender Theory",
        description: [
          "Explore leadership theories & their intersection with gender dynamics.",
          "Analyse unconscious biases & barriers to gender equality.",
        ],
      },
      {
        title: "Advanced Leadership & Strategic Thinking",
        description: [
          "Develop strategic decision-making skills for senior leadership roles.",
          "Focus on visionary leadership & change management.",
        ],
      },
      {
        title: "Advocacy, Policy, & Governance",
        description: [
          "Understand policy frameworks & develop skills to influence organisational & public policies.",
          "Study governance models & their impact on gender equality.",
        ],
      },
      {
        title: "Research Methods & Reflective Practice",
        description: [
          "Gain proficiency in qualitative & quantitative research methodologies.",
          "Apply reflective practices to evaluate personal & professional growth.",
        ],
      },
      {
        title: "Entrepreneurship & Economic Empowerment",
        description: [
          "Analyse case studies on women-led enterprises.",
          "Learn financial literacy & strategies for economic independence.",
        ],
      },
      {
        title: "Community Leadership & Social Impact",
        description: [
          "Design & execute community development projects.",
          "Integrate sustainability & social impact principles into leadership practices.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Develop a research-based project addressing a critical gender leadership challenge.",
          "Present findings to peers & mentors, demonstrating mastery of programme concepts.",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "🌟",
        title: "Senior Leadership Roles:",
        description:
          "Upon completion of the programme, you will have the skills to pursue senior leadership roles in corporate, public sector, & nonprofit organisations.",
      },
      {
        icon: "👩‍⚖️",
        title: "Gender Advocacy Specialist:",
        description:
          "Graduates will also be equipped to advocate for gender equality & empower others, positioning themselves as experts in women’s leadership & gender advocacy.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/set-up-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r12.jpg",
  },

  // The Certified Project Management Associate Data
  {
    id: "project-management-associate",
    applicationLink: "",
    backgroundImage:
      "https://images.unsplash.com/photo-1549923746-b7f3a7e3c35d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Certified Project Management Associate",
    duration: "26 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Senior Executive Women Leadership.",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business &amp; Leadership",
    credits: "60 ECTS",
    studyLevel: "Undergraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 Months / 2 Terms",
    startDate: "October 2026",
    language: "English",
    showonhomepage: true,
    miniblabforhomepage:
      "Plan, execute, & succeed! Unlock project management excellence with practical skills & a globally recognised certification. Build your career as a project leader today!",
    fees: {
      upfront: 500,
      installment: {
        total: 500,
        perInstallment: 250,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `The Project Management Associate Programme equips aspiring project managers with a strong foundation in project lifecycle management, strategic planning, & stakeholder engagement. 
     
     Combining academic theory with hands-on learning, this undergraduate diploma develops critical thinking, problem-solving, & technical skills essential for leading complex projects. 
     
     Graduates will gain the expertise to manage scope, cost, & time effectively, driving successful project outcomes in diverse industries.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "📜", // Add appropriate icon
          title: "Certification",
          description:
            "Engage in immersive live sessions to enhance your learning experience & interact with peers & instructors in real-time.",
        },
        {
          icon: "💼", // Add appropriate icon
          title: "Career Advancement",
          description:
            "Gain strategic project management skills to elevate your career.",
        },
        {
          icon: "🌍", // Add appropriate icon
          title: "Global Insights",
          description: "Learn from expert Guest Lecturers during webinars.",
        },
        {
          icon: "📝", // Add appropriate icon
          title: "Hands-On Application",
          description: "Real-world assignments & forum discussions.",
        },
        {
          icon: "🕒", // Add appropriate icon
          title: "Dedicated Support:",
          description: "Access online contact hours for personalised learning.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Stage 1",
        title: "Leadership Fundamentals",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Foundations of Leadership & Emerging Trends",
            credits: 5,
            description:
              "Explore the core principles of leadership & innovative strategies for leading in dynamic environments",
          },
          {
            title: "Communication, Influence, & Collaboration",
            credits: 5,
            description:
              "Master communication techniques, interpersonal skills, & collaboration strategies to foster influence & build effective teams.",
          },
          {
            title: "Strategic Thinking & Decision-Making",
            credits: 5,
            description:
              "Develop strategic planning & visionary thinking skills to solve complex problems & guide organisational success.",
          },
          {
            title: "Emotional Intelligence & Resilience",
            credits: 5,
            description:
              "Cultivate emotional intelligence to manage relationships effectively & build resilience in challenging situations.",
          },
        ],
      },
      {
        stage: "Stage 2",
        title: "Applied Leadership Practices",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Leadership in the Digital Age",
            credits: 5,
            description:
              "Understand how to lead effectively in a tech-driven world by leveraging digital tools & navigating digital transformation.",
          },
          {
            title: "Change Management & Adaptability",
            credits: 5,
            description:
              "Acquire the skills to lead organisational change, foster innovation, & adapt to rapidly evolving environments",
          },
          {
            title: "Global Perspectives: Leadership & Sustainability",
            credits: 10,
            description:
              "Examine global challenges, including Climate Change & the UN SDGs, & integrate sustainable leadership practices",
          },
        ],
      },
      {
        stage: "Stage 3",
        title: "Leadership Capstone & Career Development",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Capstone Project: Leadership in Action",
            credits: 15,
            description:
              "Apply your learning to a real-world leadership challenge, create meaningful impact, & present your project at the Leadership Showcase.",
          },
          {
            title: "Employability & Career Development",
            credits: 5,
            description:
              "Develop essential career skills such as personal branding, CV writing, interview techniques, & strategic career planning to enhance your professional growth.",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Fundamentals of Project Management",
        description: [
          "Introduction to project management principles, methodologies, & lifecycle phases.",
        ],
      },
      {
        title: "Stakeholder Engagement & Communication",
        description: [
          "Strategies for identifying, analysing, & managing stakeholders.",
        ],
      },
      {
        title: "Risk Management & Mitigation",
        description: [
          "Tools & techniques for risk identification, assessment, & control.",
        ],
      },
      {
        title: "Project Planning & Resource Allocation",
        description: [
          "Developing comprehensive project plans & optimising resource usage.",
        ],
      },
      {
        title: "Work Breakdown Structures & Scheduling",
        description: [
          "Analyse case studies on women-led enterprises.",
          "Learn financial literacy & strategies for economic independence.",
        ],
      },
      {
        title: "Community Leadership & Social Impact",
        description: [
          "Creating & implementing work breakdown structures (WBS) & project timelines.",
        ],
      },
      {
        title: "Financial Management in Projects",
        description: ["Budgeting, forecasting, & financial risk assessment."],
      },
      {
        title: "Change Management & Quality Assurance",
        description: [
          "Techniques for managing change & ensuring project quality.",
        ],
      },
      {
        title: "Leadership in Project Teams",
        description: ["Developing leadership styles & managing team dynamics."],
      },
      {
        title: "Monitoring, Evaluation, & Reporting",
        description: [
          "Tools & strategies for tracking progress & communicating results.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Application of acquired skills & knowledge in a comprehensive, real-world project scenario",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📋",
        title: "Project Coordinator:",
        description: "Supporting project planning & execution.",
      },
      {
        icon: "⚙️",
        title: "Operations Analyst:",
        description:
          "Streamlining operational processes & ensuring efficiency.",
      },
      {
        icon: "⚠️",
        title: "Risk Analyst:",
        description: "Identifying & mitigating project risks.",
      },
      {
        icon: "👥",
        title: "Team Leader:",
        description:
          "Managing & motivating project teams to achieve objectives.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/set-up-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r11.jpeg",
  },

  // The Certified Womens Leadership & Gender Changemaker Data
  {
    id: "womens-leadership-gender",
    applicationLink: "",
    backgroundImage: "/Image Assets/indemandprograms/lds.png",
    blurHash: "LvJa+lM_?wROE0RPWVR*M|bcV?V@",
    title: "Certified Womens Leadership & Gender Changemaker",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Senior Executive Women Leadership.",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business &amp; Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",
    showonhomepage: true,
    miniblabforhomepage:
      "Champion equality, lead with purpose! Empower yourself with leadership skills to drive change & advocate for gender balance. Shape a brighter future—apply today! ",
    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `Welcome to The Postgraduate Diploma in Senior Executive Women Leadership Programme which offers a unique opportunity to earn the esteemed Certified Women Leadership & Gender Changemaker designation.

        This comprehensive, 26-32 week Postgraduate Diploma in Senior Executive Women Leadership develops advanced expertise in leadership & gender advocacy, combining rigorous academic study with practical application. 

Designed for women leaders in diverse sectors, the programme fosters transformative leadership, critical thinking, & the ability to implement innovative solutions for promoting gender equity. 

Through a blend of theoretical frameworks, global perspectives, & real-world application, this programme prepares graduates to lead impactful change in their organisations & communities.

Learners will be awarded the prestigious Certified Women Leadership & Gender Changemaker designation upon successfully completing the Postgraduate Diploma in Senior Executive Women
Leadership.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌐", // Add appropriate icon
          title: "Live Learning Experience",
          description:
            "Engage in immersive live sessions to enhance your learning experience & interact with peers & instructors in real-time.",
        },
        {
          icon: "👩‍🏫", // Add appropriate icon
          title: "Expert Guest Lecturers",
          description:
            "Learn from leading experts & professionals who bring real-world insights to the classroom.",
        },
        {
          icon: "📚", // Add appropriate icon
          title: "Practical, Real-World Knowledge",
          description:
            "Gain actionable knowledge & hands-on experience to apply directly in your professional environment.",
        },
        {
          icon: "🎓", // Add appropriate icon
          title: "Accredited Certification",
          description:
            "Earn a certification that is globally recognised & validates your skills & knowledge.",
        },
        {
          icon: "🌍", // Add appropriate icon
          title: "Global Networking Opportunities",
          description:
            "Connect with a diverse cohort of professionals & expand your network worldwide.",
        },
        {
          icon: "💻", // Add appropriate icon
          title: "Online Contact Hours with Programme Leader",
          description:
            "Benefit from direct interaction with the programme leader to discuss concepts, clarify doubts, & receive guidance.",
        },
        {
          icon: "✨", // Add appropriate icon
          title: "Eligible for Summer School Programme",
          description:
            "Opportunity to participate in exclusive summer school programmes to further enhance your learning journey.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Stage 1",
        title: "Leadership Fundamentals",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Foundations of Leadership & Emerging Trends",
            credits: 5,
            description:
              "Explore the core principles of leadership & innovative strategies for leading in dynamic environments",
          },
          {
            title: "Communication, Influence, & Collaboration",
            credits: 5,
            description:
              "Master communication techniques, interpersonal skills, & collaboration strategies to foster influence & build effective teams.",
          },
          {
            title: "Strategic Thinking & Decision-Making",
            credits: 5,
            description:
              "Develop strategic planning & visionary thinking skills to solve complex problems & guide organisational success.",
          },
          {
            title: "Emotional Intelligence & Resilience",
            credits: 5,
            description:
              "Cultivate emotional intelligence to manage relationships effectively & build resilience in challenging situations.",
          },
        ],
      },
      {
        stage: "Stage 2",
        title: "Applied Leadership Practices",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Leadership in the Digital Age",
            credits: 5,
            description:
              "Understand how to lead effectively in a tech-driven world by leveraging digital tools & navigating digital transformation.",
          },
          {
            title: "Change Management & Adaptability",
            credits: 5,
            description:
              "Acquire the skills to lead organisational change, foster innovation, & adapt to rapidly evolving environments",
          },
          {
            title: "Global Perspectives: Leadership & Sustainability",
            credits: 10,
            description:
              "Examine global challenges, including Climate Change & the UN SDGs, & integrate sustainable leadership practices",
          },
        ],
      },
      {
        stage: "Stage 3",
        title: "Leadership Capstone & Career Development",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Capstone Project: Leadership in Action",
            credits: 15,
            description:
              "Apply your learning to a real-world leadership challenge, create meaningful impact, & present your project at the Leadership Showcase.",
          },
          {
            title: "Employability & Career Development",
            credits: 5,
            description:
              "Develop essential career skills such as personal branding, CV writing, interview techniques, & strategic career planning to enhance your professional growth.",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Leadership & Gender Theory",
        description: [
          "Explore leadership theories & their intersection with gender dynamics.",
          "Analyse unconscious biases & barriers to gender equality.",
        ],
      },
      {
        title: "Advanced Leadership & Strategic Thinking",
        description: [
          "Develop strategic decision-making skills for senior leadership roles.",
          "Focus on visionary leadership & change management.",
        ],
      },
      {
        title: "Advocacy, Policy, & Governance",
        description: [
          "Understand policy frameworks & develop skills to influence organisational & public policies.",
          "Study governance models & their impact on gender equality.",
        ],
      },
      {
        title: "Research Methods & Reflective Practice",
        description: [
          "Gain proficiency in qualitative & quantitative research methodologies.",
          "Apply reflective practices to evaluate personal & professional growth.",
        ],
      },
      {
        title: "Entrepreneurship & Economic Empowerment",
        description: [
          "Analyse case studies on women-led enterprises.",
          "Learn financial literacy & strategies for economic independence.",
        ],
      },
      {
        title: "Community Leadership & Social Impact",
        description: [
          "Design & execute community development projects.",
          "Integrate sustainability & social impact principles into leadership practices.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Develop a research-based project addressing a critical gender leadership challenge.",
          "Present findings to peers & mentors, demonstrating mastery of programme concepts.",
        ],
      },
    ],

    // Data For the Admission Section
    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "🌟",
        title: "Senior Leadership Roles:",
        description:
          "Upon completion of the programme, you will have the skills to pursue senior leadership roles in corporate, public sector, & nonprofit organisations.",
      },
      {
        icon: "👩‍⚖️",
        title: "Gender Advocacy Specialist:",
        description:
          "Graduates will also be equipped to advocate for gender equality & empower others, positioning themselves as experts in women’s leadership & gender advocacy.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/touch-click-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/port-detection-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/page-analysis-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/machine-vision-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/interface-control-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r10.jpeg",
  },

  // The Certified Agile Thought Leader Data
  {
    id: "agile-thought-leader",
    applicationLink: "",
    backgroundImage:
      "https://images.unsplash.com/photo-1648652678596-d3873bd0c157?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Certified Agile Thought Leader Diploma",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Leadership",
    possibleProgression: "Master of Arts in Leadership",
    school: "Faculty of Business &amp; Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",
    showonhomepage: true,
    miniblabforhomepage:
      "Drive innovation with agility! Master cutting-edge leadership practices to navigate complexities & inspire growth in dynamic environments. Lead the way in agile transformation—enrol now!",
    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },

    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        "Earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme.",
        "Focus on a competency-based, career-driven approach to leadership development.",
      ],
    },

    // Data For The Highlight Section
    highlights: {
      content: [
        {
          icon: "🎓", // Add appropriate icon
          title: "Postgraduate Diploma Qualification",
          description:
            "Graduates earn a Postgraduate Diploma in Leadership (60 ECTS), a globally recognised qualification.", // Add appropriate description
        },
        {
          icon: "📈", // Add appropriate icon
          title: "Progression to Master’s Degree",
          description:
            "Successful graduates can proceed directly to Stage 2 of our Master of Arts in Leadership, with exemptions granted for Stage 1 modules.", // Add appropriate description
        },
        {
          icon: "🌐", // Add appropriate icon
          title: "Global Webinars",
          description:
            "Engage in expert-led webinars with industry leaders shaping the world.",
        },
        {
          icon: "💬", // Add appropriate icon
          title: "Interactive Online Tutorials",
          description:
            "Benefit from personalised online sessions with the Programme Leader & mentors.",
        },
        {
          icon: "🔍", // Add appropriate icon
          title: "Practical Engagement",
          description:
            "Work on case studies, assignments, & a Leadership Capstone Project to apply your skills.",
        },
        {
          icon: "🌱", // Add appropriate icon
          title: "Mentorship Connect",
          description:
            "Receive one-on-one mentorship from seasoned professionals throughout the programme.",
        },
        {
          icon: "🌐", // Add appropriate icon
          title: "Global Collaboration Hub",
          description:
            "Network & collaborate with participants worldwide in a virtual leadership forum.",
        },
        {
          icon: "🚀", // Add appropriate icon
          title: "Leadership Expo",
          description:
            "Showcase your leadership journey & capstone project at a global virtual expo.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: true,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Stage 1",
        title: "Stage 1 : Leadership Fundamentals",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Foundations of Leadership & Emerging Trends",
            credits: 5,
            description:
              "Explore the core principles of leadership & innovative strategies for leading in dynamic environments",
          },
          {
            title: "Communication, Influence, & Collaboration",
            credits: 5,
            description:
              "Master communication techniques, interpersonal skills, & collaboration strategies to foster influence & build effective teams.",
          },
          {
            title: "Strategic Thinking & Decision-Making",
            credits: 5,
            description:
              "Develop strategic planning & visionary thinking skills to solve complex problems & guide organisational success.",
          },
          {
            title: "Emotional Intelligence & Resilience",
            credits: 5,
            description:
              "Cultivate emotional intelligence to manage relationships effectively & build resilience in challenging situations.",
          },
        ],
      },
      {
        stage: "Stage 2",
        title: "Stage 2 : Applied Leadership Practices",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Leadership in the Digital Age",
            credits: 5,
            description:
              "Understand how to lead effectively in a tech-driven world by leveraging digital tools & navigating digital transformation.",
          },
          {
            title: "Change Management & Adaptability",
            credits: 5,
            description:
              "Acquire the skills to lead organisational change, foster innovation, & adapt to rapidly evolving environments",
          },
          {
            title: "Global Perspectives: Leadership & Sustainability",
            credits: 10,
            description:
              "Examine global challenges, including Climate Change & the UN SDGs, & integrate sustainable leadership practices",
          },
        ],
      },
      {
        stage: "Stage 3",
        title: "Stage 3 : Leadership Capstone & Career Development",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Capstone Project: Leadership in Action",
            credits: 15,
            description:
              "Apply your learning to a real-world leadership challenge, create meaningful impact, & present your project at the Leadership Showcase.",
          },
          {
            title: "Employability & Career Development",
            credits: 5,
            description:
              "Develop essential career skills such as personal branding, CV writing, interview techniques, & strategic career planning to enhance your professional growth.",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Leadership & Gender Theory:",
        description:
          "Explore leadership theories & their intersection with gender dynamics. Analyse unconscious biases & barriers to gender equality.",
      },
      {
        title: "Advanced Leadership & Strategic Thinking:",
        description:
          "Develop strategic decision-making skills for senior leadership roles. Focus on visionary leadership & change management.",
      },
      {
        title: "Advocacy, Policy, & Governance:",
        description:
          "Understand policy frameworks & develop skills to influence organisational & public policies. Study governance models & their impact on gender equality.",
      },
      {
        title: "Research Methods & Reflective Practice:",
        description:
          "Gain proficiency in qualitative & quantitative research methodologies. Apply reflective practices to evaluate personal & professional growth.",
      },
      {
        title: "Entrepreneurship & Economic Empowerment:",
        description:
          "Analyse case studies on women-led enterprises. Learn financial literacy & strategies for economic independence.",
      },
      {
        title: "Community Leadership & Social Impact:",
        description:
          "Design & execute community development projects. Integrate sustainability & social impact principles into leadership practices.",
      },
      {
        title: "Capstone Project:",
        description:
          "Develop a research-based project addressing a critical gender leadership challenge. Present findings to peers & mentors, demonstrating mastery of programme concepts.",
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completion of Senior Secondary/Secondary Education or equivalent.",
        },
        {
          title: "Academic Background:",
          description:
            "A Bachelor’s degree, undergraduate degree, or its equivalent.",
        },
        {
          title: "Educational Requirements:",
          description:
            " Strong communication skills in English, both written & spoken.",
        },
        {
          title: "Proficiency in English:",
          description:
            "Previous leadership experience, including voluntary or informal leadership roles.",
        },
        {
          title: "Passion for Leadership:",
          description:
            "A strong commitment to making a positive impact through leadership.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "English as the language of instruction in formal education",
        "Equivalent qualifications",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description: "Internet-enabled devices (computer, laptop, tablet)",
      },
      {
        icon: "🎧",
        description: "Speakers/headphones, webcam, & microphone",
      },
      {
        icon: "🎥",
        description:
          "Video-based teaching platforms & the course’s Virtual Learning Environment (VLE)",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📚",
        title: "Leadership Development Specialist:",
        description:
          "Designing & delivering leadership training programs within organisations to develop emerging leaders & high-potential employees.",
      },
      {
        icon: "📈",
        title: "Agile Project Manager:",
        description:
          "Leading cross-functional teams to implement agile methodologies, ensuring project success through adaptive planning, continuous improvement, & effective collaboration.",
      },
      {
        icon: "🔄",
        title: "Change Management Consultant:",
        description:
          "Advising organisations on how to manage & implement change effectively, with a focus on leadership strategies, employee engagement, & organisational culture.",
      },
      {
        icon: "💼",
        title: "Corporate Strategist:",
        description:
          "Developing & executing strategic initiatives that drive business growth & innovation, using the skills in strategic thinking & visionary leadership gained from the programme.",
      },
      {
        icon: "🤝",
        title: "Leadership Coach or Mentor:",
        description:
          "Providing one-on-one coaching or mentoring to individuals in leadership roles, helping them navigate challenges & develop their leadership potential in both corporate & non-profit environments.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/score-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/certificate-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/attend-class-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r9.jpeg",
  },

  // The Certified Data Analyst Data
  {
    id: "data-analyst",
    applicationLink: "",
    backgroundImage: "/Image Assets/indemandprograms/data-analyst-img1.jpg",
    title: "Certified Data Analyst",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Business Consultancy",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Computer Science",
    credits: "60 ECTS",
    studyLevel: "Undergraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 Months / 2 Terms",
    startDate: "October 2026",
    language: "English",
    showonhomepage: true,
    miniblabforhomepage:
      "Turn data into decisions! Master analytical thinking to uncover patterns, visualize insights & drive impact. Lead with evidence—become a Certified Data Analyst—enrol now!",
    fees: {
      upfront: 500,
      installment: {
        total: 850,
        perInstallment: 250,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `This programme develops advanced analytical capabilities, fostering a deep understanding of data transformation techniques, statistical analysis, & data storytelling. 

Students will engage with cutting-edge technologies & methodologies while cultivating critical thinking, problem-solving, & ethical considerations essential for global data industries. 

Designed to bridge academic knowledge & professional practice, the programme empowers students to lead data-driven innovation across sectors.

Enrol today to unlock the power of data & drive success with data-driven strategies!`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌍",
          title: "Global Recognised Certification",
          description:
            "Earn a globally recognised certification to boost your professional credentials.",
        },
        {
          icon: "📚",
          title: "Flexible Learning",
          description:
            "Participate in 100 hours of live teaching & self-paced learning for maximum flexibility.",
        },
        {
          icon: "🤝",
          title: "Networking Opportunities",
          description:
            "Connect with a global cohort of professionals & industry experts to expand your network.",
        },
        {
          icon: "🛠️",
          title: "Practical Projects",
          description:
            "Apply skills to real-world scenarios through case studies, workshops, & a capstone project.",
        },
        {
          icon: "🏆",
          title: "Career Advancement",
          description:
            "Gain exemptions/credits for diploma or degree programmes with Mila University.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Foundation",
        title: "Foundation Level: Theoretical Foundations of Career Coaching",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Introduction to Career Coaching Principles & Practices",
            credits: 5,
            description: "--",
          },
          {
            title: "Communication & Relationship-Building Strategies",
            credits: 5,
            description: "--",
          },
          {
            title: "Goal Setting & Career Planning Frameworks",
            credits: 5,
            description: "--",
          },
          {
            title: "Reflective Practice in Coaching",
            credits: 5,
            description: "--",
          },
        ],
      },
      {
        stage: "Advanced",
        title: "Advanced Level: Application & Ethics",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Advanced Coaching Methodologies & Techniques",
            credits: 5,
            description: "--",
          },
          {
            title:
              "Use of Psychometric & Assessment Tools in Career Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Coaching Ethics & Professional Standards",
            credits: 10,
            description: "--",
          },
          {
            title: "Research Methods for Career Coaching Practices",
            credits: 10,
            description: "--",
          },
        ],
      },
      {
        stage: "Masters",
        title: "Master’s Level: Leadership & Strategic Coaching",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Leadership & Executive Coaching Strategies",
            credits: 15,
            description: "--",
          },
          {
            title: "Entrepreneurial Coaching & Business Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Advanced Organisational Behaviour & Change Management",
            credits: 5,
            description: "--",
          },
          {
            title: "Capstone Project: Research-Based Coaching Intervention",
            credits: 5,
            description: "--",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Introduction to Data Analytics",
        description: [
          "Understand the core concepts & methodologies of data analysis.",
        ],
      },
      {
        title: "Foundations of Data Analysis",
        description: [
          "Explore data collection, cleansing, & preparation methods.",
        ],
      },
      {
        title: "Advanced Statistical Methods",
        description: [
          "Conduct in-depth statistical analyses to inform decision-making.",
        ],
      },
      {
        title: "Data Ethics & Governance",
        description: ["Examine the ethical & legal aspects of data handling."],
      },
      {
        title: "Data Visualisation & Communication",
        description: [
          "Design impactful visualisations & present findings to diverse audiences.",
        ],
      },
      {
        title: "Applied Data Analytics",
        description: [
          "Solve complex problems through real-world projects & case studies.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Develop & present a comprehensive data analysis project integrating all learned skills.",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📊",
        title: "Data Analyst:",
        description:
          "Analyse & interpret complex datasets to provide insights for decision-making.",
      },
      {
        icon: "📈",
        title: "Business Intelligence Analyst:",
        description:
          "Help organisations use data to enhance business performance & strategy.",
      },
      {
        icon: "📊",
        title: "Data Visualisation Specialist:",
        description:
          "Create clear, effective visualisations to communicate data-driven insights.",
      },
      {
        icon: "🧑‍💻",
        title: "Data Consultant:",
        description:
          "Provide expert advice to organisations on how to optimise their data & analytics processes.",
      },
      {
        icon: "📉",
        title: "Market Research Analyst:",
        description:
          "Use data to understand market trends & consumer behaviour.",
      },
      {
        icon: "⚙️",
        title: "Operations Analyst:",
        description:
          "Analyse operational data to identify inefficiencies & recommend improvements.",
      },
      {
        icon: "💵",
        title: "Financial Analyst:",
        description:
          "Apply data analysis techniques to support financial decision-making & forecasting.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/touch-click-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/port-detection-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/page-analysis-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/machine-vision-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/interface-control-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],
  },

  // ---------------Undergraduate Programs---------------- //

  // Certified Data Analyst - (undergrad)
  {
    id: "data-analyst-undegrad",
    applicationLink: "",
    backgroundImage:
      "/image-fix/academic-programmes/certified-courses/images/bg08.png",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Undergraduate Diploma In Data Analyst",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Business Consultancy",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Computer Science",
    credits: "60 ECTS",
    studyLevel: "Undergraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 Months / 2 Terms",
    startDate: "October 2026",
    language: "English",

    fees: {
      upfront: 500,
      installment: {
        total: 850,
        perInstallment: 250,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `This programme develops advanced analytical capabilities, fostering a deep understanding of data transformation techniques, statistical analysis, & data storytelling. 

Students will engage with cutting-edge technologies & methodologies while cultivating critical thinking, problem-solving, & ethical considerations essential for global data industries. 

Designed to bridge academic knowledge & professional practice, the programme empowers students to lead data-driven innovation across sectors.

Enrol today to unlock the power of data & drive success with data-driven strategies!`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌍",
          title: "Global Recognised Certification",
          description:
            "Earn a globally recognised certification to boost your professional credentials.",
        },
        {
          icon: "📚",
          title: "Flexible Learning",
          description:
            "Participate in 100 hours of live teaching & self-paced learning for maximum flexibility.",
        },
        {
          icon: "🤝",
          title: "Networking Opportunities",
          description:
            "Connect with a global cohort of professionals & industry experts to expand your network.",
        },
        {
          icon: "🛠️",
          title: "Practical Projects",
          description:
            "Apply skills to real-world scenarios through case studies, workshops, & a capstone project.",
        },
        {
          icon: "🏆",
          title: "Career Advancement",
          description:
            "Gain exemptions/credits for diploma or degree programmes with Mila University.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Foundation",
        title: "Foundation Level: Theoretical Foundations of Career Coaching",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Introduction to Career Coaching Principles & Practices",
            credits: 5,
            description: "--",
          },
          {
            title: "Communication & Relationship-Building Strategies",
            credits: 5,
            description: "--",
          },
          {
            title: "Goal Setting & Career Planning Frameworks",
            credits: 5,
            description: "--",
          },
          {
            title: "Reflective Practice in Coaching",
            credits: 5,
            description: "--",
          },
        ],
      },
      {
        stage: "Advanced",
        title: "Advanced Level: Application & Ethics",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Advanced Coaching Methodologies & Techniques",
            credits: 5,
            description: "--",
          },
          {
            title:
              "Use of Psychometric & Assessment Tools in Career Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Coaching Ethics & Professional Standards",
            credits: 10,
            description: "--",
          },
          {
            title: "Research Methods for Career Coaching Practices",
            credits: 10,
            description: "--",
          },
        ],
      },
      {
        stage: "Masters",
        title: "Master’s Level: Leadership & Strategic Coaching",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Leadership & Executive Coaching Strategies",
            credits: 15,
            description: "--",
          },
          {
            title: "Entrepreneurial Coaching & Business Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Advanced Organisational Behaviour & Change Management",
            credits: 5,
            description: "--",
          },
          {
            title: "Capstone Project: Research-Based Coaching Intervention",
            credits: 5,
            description: "--",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Introduction to Data Analytics",
        description: [
          "Understand the core concepts & methodologies of data analysis.",
        ],
      },
      {
        title: "Foundations of Data Analysis",
        description: [
          "Explore data collection, cleansing, & preparation methods.",
        ],
      },
      {
        title: "Advanced Statistical Methods",
        description: [
          "Conduct in-depth statistical analyses to inform decision-making.",
        ],
      },
      {
        title: "Data Ethics & Governance",
        description: ["Examine the ethical & legal aspects of data handling."],
      },
      {
        title: "Data Visualisation & Communication",
        description: [
          "Design impactful visualisations & present findings to diverse audiences.",
        ],
      },
      {
        title: "Applied Data Analytics",
        description: [
          "Solve complex problems through real-world projects & case studies.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Develop & present a comprehensive data analysis project integrating all learned skills.",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📊",
        title: "Data Analyst:",
        description:
          "Analyse & interpret complex datasets to provide insights for decision-making.",
      },
      {
        icon: "📈",
        title: "Business Intelligence Analyst:",
        description:
          "Help organisations use data to enhance business performance & strategy.",
      },
      {
        icon: "📊",
        title: "Data Visualisation Specialist:",
        description:
          "Create clear, effective visualisations to communicate data-driven insights.",
      },
      {
        icon: "🧑‍💻",
        title: "Data Consultant:",
        description:
          "Provide expert advice to organisations on how to optimise their data & analytics processes.",
      },
      {
        icon: "📉",
        title: "Market Research Analyst:",
        description:
          "Use data to understand market trends & consumer behaviour.",
      },
      {
        icon: "⚙️",
        title: "Operations Analyst:",
        description:
          "Analyse operational data to identify inefficiencies & recommend improvements.",
      },
      {
        icon: "💵",
        title: "Financial Analyst:",
        description:
          "Apply data analysis techniques to support financial decision-making & forecasting.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/touch-click-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/port-detection-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/page-analysis-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/machine-vision-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/interface-control-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],
  },

  // certified project management assosiate - (undergrad)
  {
    id: "project-management-associate-undergrad",
    applicationLink: "",
    backgroundImage:
      "/image-fix/academic-programmes/certified-courses/images/bg07.png",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Undergraduate Diploma in Project Management Associate",
    duration: "26 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Senior Executive Women Leadership.",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business &amp; Leadership",
    credits: "60 ECTS",
    studyLevel: "Undergraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 Months / 2 Terms",
    startDate: "October 2026",
    language: "English",

    fees: {
      upfront: 500,
      installment: {
        total: 500,
        perInstallment: 250,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `The Project Management Associate Programme equips aspiring project managers with a strong foundation in project lifecycle management, strategic planning, & stakeholder engagement. 
       
       Combining academic theory with hands-on learning, this undergraduate diploma develops critical thinking, problem-solving, & technical skills essential for leading complex projects. 
       
       Graduates will gain the expertise to manage scope, cost, & time effectively, driving successful project outcomes in diverse industries.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "📜", // Add appropriate icon
          title: "Certification",
          description:
            "Engage in immersive live sessions to enhance your learning experience & interact with peers & instructors in real-time.",
        },
        {
          icon: "💼", // Add appropriate icon
          title: "Career Advancement",
          description:
            "Gain strategic project management skills to elevate your career.",
        },
        {
          icon: "🌍", // Add appropriate icon
          title: "Global Insights",
          description: "Learn from expert Guest Lecturers during webinars.",
        },
        {
          icon: "📝", // Add appropriate icon
          title: "Hands-On Application",
          description: "Real-world assignments & forum discussions.",
        },
        {
          icon: "🕒", // Add appropriate icon
          title: "Dedicated Support:",
          description: "Access online contact hours for personalised learning.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Stage 1",
        title: "Leadership Fundamentals",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Foundations of Leadership & Emerging Trends",
            credits: 5,
            description:
              "Explore the core principles of leadership & innovative strategies for leading in dynamic environments",
          },
          {
            title: "Communication, Influence, & Collaboration",
            credits: 5,
            description:
              "Master communication techniques, interpersonal skills, & collaboration strategies to foster influence & build effective teams.",
          },
          {
            title: "Strategic Thinking & Decision-Making",
            credits: 5,
            description:
              "Develop strategic planning & visionary thinking skills to solve complex problems & guide organisational success.",
          },
          {
            title: "Emotional Intelligence & Resilience",
            credits: 5,
            description:
              "Cultivate emotional intelligence to manage relationships effectively & build resilience in challenging situations.",
          },
        ],
      },
      {
        stage: "Stage 2",
        title: "Applied Leadership Practices",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Leadership in the Digital Age",
            credits: 5,
            description:
              "Understand how to lead effectively in a tech-driven world by leveraging digital tools & navigating digital transformation.",
          },
          {
            title: "Change Management & Adaptability",
            credits: 5,
            description:
              "Acquire the skills to lead organisational change, foster innovation, & adapt to rapidly evolving environments",
          },
          {
            title: "Global Perspectives: Leadership & Sustainability",
            credits: 10,
            description:
              "Examine global challenges, including Climate Change & the UN SDGs, & integrate sustainable leadership practices",
          },
        ],
      },
      {
        stage: "Stage 3",
        title: "Leadership Capstone & Career Development",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Capstone Project: Leadership in Action",
            credits: 15,
            description:
              "Apply your learning to a real-world leadership challenge, create meaningful impact, & present your project at the Leadership Showcase.",
          },
          {
            title: "Employability & Career Development",
            credits: 5,
            description:
              "Develop essential career skills such as personal branding, CV writing, interview techniques, & strategic career planning to enhance your professional growth.",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Fundamentals of Project Management",
        description: [
          "Introduction to project management principles, methodologies, & lifecycle phases.",
        ],
      },
      {
        title: "Stakeholder Engagement & Communication",
        description: [
          "Strategies for identifying, analysing, & managing stakeholders.",
        ],
      },
      {
        title: "Risk Management & Mitigation",
        description: [
          "Tools & techniques for risk identification, assessment, & control.",
        ],
      },
      {
        title: "Project Planning & Resource Allocation",
        description: [
          "Developing comprehensive project plans & optimising resource usage.",
        ],
      },
      {
        title: "Work Breakdown Structures & Scheduling",
        description: [
          "Analyse case studies on women-led enterprises.",
          "Learn financial literacy & strategies for economic independence.",
        ],
      },
      {
        title: "Community Leadership & Social Impact",
        description: [
          "Creating & implementing work breakdown structures (WBS) & project timelines.",
        ],
      },
      {
        title: "Financial Management in Projects",
        description: ["Budgeting, forecasting, & financial risk assessment."],
      },
      {
        title: "Change Management & Quality Assurance",
        description: [
          "Techniques for managing change & ensuring project quality.",
        ],
      },
      {
        title: "Leadership in Project Teams",
        description: ["Developing leadership styles & managing team dynamics."],
      },
      {
        title: "Monitoring, Evaluation, & Reporting",
        description: [
          "Tools & strategies for tracking progress & communicating results.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Application of acquired skills & knowledge in a comprehensive, real-world project scenario",
        ],
      },
    ],

    // Data For the Admission Section
    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📋",
        title: "Project Coordinator:",
        description: "Supporting project planning & execution.",
      },
      {
        icon: "⚙️",
        title: "Operations Analyst:",
        description:
          "Streamlining operational processes & ensuring efficiency.",
      },
      {
        icon: "⚠️",
        title: "Risk Analyst:",
        description: "Identifying & mitigating project risks.",
      },
      {
        icon: "👥",
        title: "Team Leader:",
        description:
          "Managing & motivating project teams to achieve objectives.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/set-up-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r11.jpeg",
  },

  // ---------------Postgraduate Programs---------------- //

  // The Certified Business Consultant Data -(postgrad)
  {
    id: "business-consultant-postgrad",
    applicationLink: "",
    backgroundImage:
      "/image-fix/academic-programmes/certified-courses/images/bg05.png",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Postgraduate Diploma In Business Consultant",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Business Consultancy",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business & Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",

    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `Welcome to The Postgraduate Diploma in Business Consultancy Programme which offers a unique opportunity to earn the esteemed Certified Business Consultant designation.
    
    The Postgraduate Diploma in Business Consultancy equips professionals with advanced expertise in strategic consulting, financial analysis, marketing, & global business dynamics. 
    
    Designed for career progression, the programme fosters critical thinking, research-based decision-making, & innovative problem-solving in complex business environments. 
    
    Combining academic rigour with practical application, this programme prepares graduates to become thought leaders in business consultancy & management.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌍",
          title: "Global Recognised Certification",
          description:
            "Earn a globally recognised certification to boost your professional credentials.",
        },
        {
          icon: "📚",
          title: "Flexible Learning",
          description:
            "Participate in 100 hours of live teaching & self-paced learning for maximum flexibility.",
        },
        {
          icon: "🤝",
          title: "Networking Opportunities",
          description:
            "Connect with a global cohort of professionals & industry experts to expand your network.",
        },
        {
          icon: "🛠️",
          title: "Practical Projects",
          description:
            "Apply skills to real-world scenarios through case studies, workshops, & a capstone project.",
        },
        {
          icon: "🏆",
          title: "Career Advancement",
          description:
            "Gain exemptions/credits for diploma or degree programmes with Mila University.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Foundation",
        title: "Foundation Level: Theoretical Foundations of Career Coaching",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Introduction to Career Coaching Principles & Practices",
            credits: 5,
            description: "--",
          },
          {
            title: "Communication & Relationship-Building Strategies",
            credits: 5,
            description: "--",
          },
          {
            title: "Goal Setting & Career Planning Frameworks",
            credits: 5,
            description: "--",
          },
          {
            title: "Reflective Practice in Coaching",
            credits: 5,
            description: "--",
          },
        ],
      },
      {
        stage: "Advanced",
        title: "Advanced Level: Application & Ethics",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Advanced Coaching Methodologies & Techniques",
            credits: 5,
            description: "--",
          },
          {
            title:
              "Use of Psychometric & Assessment Tools in Career Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Coaching Ethics & Professional Standards",
            credits: 10,
            description: "--",
          },
          {
            title: "Research Methods for Career Coaching Practices",
            credits: 10,
            description: "--",
          },
        ],
      },
      {
        stage: "Masters",
        title: "Master’s Level: Leadership & Strategic Coaching",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Leadership & Executive Coaching Strategies",
            credits: 15,
            description: "--",
          },
          {
            title: "Entrepreneurial Coaching & Business Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Advanced Organisational Behaviour & Change Management",
            credits: 5,
            description: "--",
          },
          {
            title: "Capstone Project: Research-Based Coaching Intervention",
            credits: 5,
            description: "--",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Business Consultancy",
        description: [
          "Explore the theoretical foundations of consultancy, including client management & consultancy lifecycle.",
        ],
      },
      {
        title: "Advanced Strategic Management",
        description: [
          "Apply strategic frameworks to solve complex organisational challenges.",
          "Incorporate technology & innovation into consulting practices.",
        ],
      },
      {
        title: "Financial Analysis for Consultants",
        description: [
          "Analyse financial statements, forecasting models, & risk management strategies to provide actionable insights.",
        ],
      },
      {
        title: "Marketing & Branding for Consultants",
        description: [
          "Develop advanced marketing plans & leverage digital tools for branding & client acquisition.",
        ],
      },
      {
        title: "Ethics & Legal Compliance in Consultancy",
        description: [
          "Examine legal frameworks, client confidentiality, & ethical dilemmas in consultancy.",
        ],
      },
      {
        title: "Advanced Data Analytics & Technology",
        description: [
          "Master data-driven decision-making using advanced tools & methodologies.",
        ],
      },
      {
        title: "Training & Mentorship in Consultancy",
        description: [
          "Design & deliver training programmes, applying adult learning principles & mentoring techniques.",
        ],
      },
      {
        title: "Global Business & Entrepreneurship",
        description: [
          "Address the complexities of globalisation, international trade, & cross-cultural management.",
          "Learn business ideation & venture creation strategies.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Conduct research to solve a real-world business problem, demonstrating integration of knowledge across modules.",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📊",
        title: "Business Consultant:",
        description:
          "Provide expert advice to businesses to improve performance & efficiency.",
      },
      {
        icon: "💵",
        title: "Financial Analyst:",
        description:
          "Analyse financial data & provide insights to support strategic decision-making.",
      },
      {
        icon: "📈",
        title: "Strategic Manager:",
        description:
          "Develop & implement strategies to achieve long-term organisational goals.",
      },
      {
        icon: "📢",
        title: "Marketing Consultant:",
        description:
          "Design & execute marketing strategies to enhance brand presence & client acquisition.",
      },
      {
        icon: "🎓",
        title: "Corporate Trainer:",
        description:
          "Deliver professional development programmes & workshops to enhance employee skills.",
      },
      {
        icon: "🌍",
        title: "International Business Advisor:",
        description:
          "Provide guidance on global business practices, cross-border trade, & market entry strategies.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/score-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/certificate-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/attend-class-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r11.jpeg",
  },

  // Certfied Execuive Carreer Coach -(postgrad)
  {
    id: "executive-career-coach-postgrad",
    applicationLink: "",
    backgroundImage:
      "/image-fix/academic-programmes/certified-courses/images/bg06.png",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Postgraduate Diploma In Executive Career Coach",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Executive Career Coaching",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business & Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",

    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `Elevate your career with the Postgraduate Diploma in Executive Career Coaching. This programme, offered by ESBD, awards the distinguished Certified Executive Career Coach designation, equipping you to excel as a leader in career coaching & professional development.
  
  The 26 – 32 week immersive Postgraduate Diploma in Executive Career Coaching develops advanced expertise in career coaching, combining rigorous theoretical frameworks with practical application.
  
  Participants will master coaching methodologies, ethical practices, & innovative strategies to support professionals in achieving career success.
  
  Through research-led learning, critical analysis, & leadership development, this programme equips graduates to become transformative leaders in career coaching, capable of driving organisational & individual growth in diverse professional contexts.
  
  With a focus on remote learning & practical application, the programme caters to both seasoned professionals & newcomers to the field, ensuring personal & professional growth.
  
  This Programme is designed to provide participants with an in-depth understanding & advanced expertise of career coaching principles & practices. Delivered across three progressive
  
  levels—Foundation, Advanced, & Master’s—the programme integrates theory & practical exercises to develop your expertise in coaching, leadership, & career development.
  
  This comprehensive course is ideal for those passionate about guiding others toward achieving career goals & professional fulfilment.
  
  Learners will be awarded the prestigious Certified Executive Career Coach designation upon successfully completing the Postgraduate Diploma in Executive Career Coaching.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌟",
          title: "Expert-Led Webinars",
          description:
            "Engage in two webinar series featuring renowned guest lecturers, offering insights into key career coaching themes.",
        },
        {
          icon: "💬",
          title: "Interactive Online Tutorials",
          description:
            "Access dedicated online tutorials with programme leaders & industry experts for personalised support.",
        },
        {
          icon: "📝",
          title: "Practical Engagement",
          description:
            "Apply knowledge through assignments, case studies, forum discussions, & a capstone project.",
        },
        {
          icon: "📜",
          title: "Certified Recognition",
          description:
            "Earn the prestigious Certified Executive Career Coach title upon completion.",
        },
        {
          icon: "🌐",
          title: "Networking Opportunities",
          description:
            "Collaborate with peers & mentors to build a global professional network.",
        },
        {
          icon: "🎓",
          title: "Eligible for Summer School Programme",
          description:
            "Participants can enhance their learning experience through an optional Summer School Programme.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: true,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Foundation",
        title: "Foundation Level: Theoretical Foundations of Career Coaching",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Introduction to Career Coaching Principles & Practices",
            credits: 5,
            description: "--",
          },
          {
            title: "Communication & Relationship-Building Strategies",
            credits: 5,
            description: "--",
          },
          {
            title: "Goal Setting & Career Planning Frameworks",
            credits: 5,
            description: "--",
          },
          {
            title: "Reflective Practice in Coaching",
            credits: 5,
            description: "--",
          },
        ],
      },
      {
        stage: "Advanced",
        title: "Advanced Level: Application & Ethics",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Advanced Coaching Methodologies & Techniques",
            credits: 5,
            description: "--",
          },
          {
            title:
              "Use of Psychometric & Assessment Tools in Career Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Coaching Ethics & Professional Standards",
            credits: 10,
            description: "--",
          },
          {
            title: "Research Methods for Career Coaching Practices",
            credits: 10,
            description: "--",
          },
        ],
      },
      {
        stage: "Masters",
        title: "Master’s Level: Leadership & Strategic Coaching",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Leadership & Executive Coaching Strategies",
            credits: 15,
            description: "--",
          },
          {
            title: "Entrepreneurial Coaching & Business Development",
            credits: 5,
            description: "--",
          },
          {
            title: "Advanced Organisational Behaviour & Change Management",
            credits: 5,
            description: "--",
          },
          {
            title: "Capstone Project: Research-Based Coaching Intervention",
            credits: 5,
            description: "--",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Leadership & Gender Theory",
        description: [
          "Explore leadership theories & their intersection with gender dynamics.",
          "Analyse unconscious biases & barriers to gender equality.",
        ],
      },
      {
        title: "Advanced Leadership & Strategic Thinking",
        description: [
          "Develop strategic decision-making skills for senior leadership roles.",
          "Focus on visionary leadership & change management.",
        ],
      },
      {
        title: "Advocacy, Policy, & Governance",
        description: [
          "Understand policy frameworks & develop skills to influence organisational & public policies.",
          "Study governance models & their impact on gender equality.",
        ],
      },
      {
        title: "Research Methods & Reflective Practice",
        description: [
          "Gain proficiency in qualitative & quantitative research methodologies.",
          "Apply reflective practices to evaluate personal & professional growth.",
        ],
      },
      {
        title: "Entrepreneurship & Economic Empowerment",
        description: [
          "Analyse case studies on women-led enterprises.",
          "Learn financial literacy & strategies for economic independence.",
        ],
      },
      {
        title: "Community Leadership & Social Impact",
        description: [
          "Design & execute community development projects.",
          "Integrate sustainability & social impact principles into leadership practices.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Develop a research-based project addressing a critical gender leadership challenge.",
          "Present findings to peers & mentors, demonstrating mastery of programme concepts.",
        ],
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "🌟",
        title: "Senior Leadership Roles:",
        description:
          "Upon completion of the programme, you will have the skills to pursue senior leadership roles in corporate, public sector, & nonprofit organisations.",
      },
      {
        icon: "👩‍⚖️",
        title: "Gender Advocacy Specialist:",
        description:
          "Graduates will also be equipped to advocate for gender equality & empower others, positioning themselves as experts in women’s leadership & gender advocacy.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/address-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/accelerate-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/trophy-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/network-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/business-duotone-pack/set-up-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r12.jpg",
  },

  // Agile Thought Leader (Postgrad)
  {
    id: "agile-thought-leader-postgrad",
    applicationLink: "",
    backgroundImage:
      "/image-fix/academic-programmes/certified-courses/images/bg02.png",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Postgraduate Diploma in Agile Thought Leader Diploma",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Leadership",
    possibleProgression: "Master of Arts in Leadership",
    school: "Faculty of Business &amp; Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",

    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        "Earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme.",
        "Focus on a competency-based, career-driven approach to leadership development.",
      ],
    },

    // Data For The Highlight Section
    highlights: {
      content: [
        {
          icon: "🎓", // Add appropriate icon
          title: "Postgraduate Diploma Qualification",
          description:
            "Graduates earn a Postgraduate Diploma in Leadership (60 ECTS), a globally recognised qualification.", // Add appropriate description
        },
        {
          icon: "📈", // Add appropriate icon
          title: "Progression to Master’s Degree",
          description:
            "Successful graduates can proceed directly to Stage 2 of our Master of Arts in Leadership, with exemptions granted for Stage 1 modules.", // Add appropriate description
        },
        {
          icon: "🌐", // Add appropriate icon
          title: "Global Webinars",
          description:
            "Engage in expert-led webinars with industry leaders shaping the world.",
        },
        {
          icon: "💬", // Add appropriate icon
          title: "Interactive Online Tutorials",
          description:
            "Benefit from personalised online sessions with the Programme Leader & mentors.",
        },
        {
          icon: "🔍", // Add appropriate icon
          title: "Practical Engagement",
          description:
            "Work on case studies, assignments, & a Leadership Capstone Project to apply your skills.",
        },
        {
          icon: "🌱", // Add appropriate icon
          title: "Mentorship Connect",
          description:
            "Receive one-on-one mentorship from seasoned professionals throughout the programme.",
        },
        {
          icon: "🌐", // Add appropriate icon
          title: "Global Collaboration Hub",
          description:
            "Network & collaborate with participants worldwide in a virtual leadership forum.",
        },
        {
          icon: "🚀", // Add appropriate icon
          title: "Leadership Expo",
          description:
            "Showcase your leadership journey & capstone project at a global virtual expo.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: true,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Stage 1",
        title: "Stage 1 : Leadership Fundamentals",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Foundations of Leadership & Emerging Trends",
            credits: 5,
            description:
              "Explore the core principles of leadership & innovative strategies for leading in dynamic environments",
          },
          {
            title: "Communication, Influence, & Collaboration",
            credits: 5,
            description:
              "Master communication techniques, interpersonal skills, & collaboration strategies to foster influence & build effective teams.",
          },
          {
            title: "Strategic Thinking & Decision-Making",
            credits: 5,
            description:
              "Develop strategic planning & visionary thinking skills to solve complex problems & guide organisational success.",
          },
          {
            title: "Emotional Intelligence & Resilience",
            credits: 5,
            description:
              "Cultivate emotional intelligence to manage relationships effectively & build resilience in challenging situations.",
          },
        ],
      },
      {
        stage: "Stage 2",
        title: "Stage 2 : Applied Leadership Practices",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Leadership in the Digital Age",
            credits: 5,
            description:
              "Understand how to lead effectively in a tech-driven world by leveraging digital tools & navigating digital transformation.",
          },
          {
            title: "Change Management & Adaptability",
            credits: 5,
            description:
              "Acquire the skills to lead organisational change, foster innovation, & adapt to rapidly evolving environments",
          },
          {
            title: "Global Perspectives: Leadership & Sustainability",
            credits: 10,
            description:
              "Examine global challenges, including Climate Change & the UN SDGs, & integrate sustainable leadership practices",
          },
        ],
      },
      {
        stage: "Stage 3",
        title: "Stage 3 : Leadership Capstone & Career Development",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Capstone Project: Leadership in Action",
            credits: 15,
            description:
              "Apply your learning to a real-world leadership challenge, create meaningful impact, & present your project at the Leadership Showcase.",
          },
          {
            title: "Employability & Career Development",
            credits: 5,
            description:
              "Develop essential career skills such as personal branding, CV writing, interview techniques, & strategic career planning to enhance your professional growth.",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Leadership & Gender Theory:",
        description:
          "Explore leadership theories & their intersection with gender dynamics. Analyse unconscious biases & barriers to gender equality.",
      },
      {
        title: "Advanced Leadership & Strategic Thinking:",
        description:
          "Develop strategic decision-making skills for senior leadership roles. Focus on visionary leadership & change management.",
      },
      {
        title: "Advocacy, Policy, & Governance:",
        description:
          "Understand policy frameworks & develop skills to influence organisational & public policies. Study governance models & their impact on gender equality.",
      },
      {
        title: "Research Methods & Reflective Practice:",
        description:
          "Gain proficiency in qualitative & quantitative research methodologies. Apply reflective practices to evaluate personal & professional growth.",
      },
      {
        title: "Entrepreneurship & Economic Empowerment:",
        description:
          "Analyse case studies on women-led enterprises. Learn financial literacy & strategies for economic independence.",
      },
      {
        title: "Community Leadership & Social Impact:",
        description:
          "Design & execute community development projects. Integrate sustainability & social impact principles into leadership practices.",
      },
      {
        title: "Capstone Project:",
        description:
          "Develop a research-based project addressing a critical gender leadership challenge. Present findings to peers & mentors, demonstrating mastery of programme concepts.",
      },
    ],

    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completion of Senior Secondary/Secondary Education or equivalent.",
        },
        {
          title: "Academic Background:",
          description:
            "A Bachelor’s degree, undergraduate degree, or its equivalent.",
        },
        {
          title: "Educational Requirements:",
          description:
            " Strong communication skills in English, both written & spoken.",
        },
        {
          title: "Proficiency in English:",
          description:
            "Previous leadership experience, including voluntary or informal leadership roles.",
        },
        {
          title: "Passion for Leadership:",
          description:
            "A strong commitment to making a positive impact through leadership.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "English as the language of instruction in formal education",
        "Equivalent qualifications",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description: "Internet-enabled devices (computer, laptop, tablet)",
      },
      {
        icon: "🎧",
        description: "Speakers/headphones, webcam, & microphone",
      },
      {
        icon: "🎥",
        description:
          "Video-based teaching platforms & the course’s Virtual Learning Environment (VLE)",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "📚",
        title: "Leadership Development Specialist:",
        description:
          "Designing & delivering leadership training programs within organisations to develop emerging leaders & high-potential employees.",
      },
      {
        icon: "📈",
        title: "Agile Project Manager:",
        description:
          "Leading cross-functional teams to implement agile methodologies, ensuring project success through adaptive planning, continuous improvement, & effective collaboration.",
      },
      {
        icon: "🔄",
        title: "Change Management Consultant:",
        description:
          "Advising organisations on how to manage & implement change effectively, with a focus on leadership strategies, employee engagement, & organisational culture.",
      },
      {
        icon: "💼",
        title: "Corporate Strategist:",
        description:
          "Developing & executing strategic initiatives that drive business growth & innovation, using the skills in strategic thinking & visionary leadership gained from the programme.",
      },
      {
        icon: "🤝",
        title: "Leadership Coach or Mentor:",
        description:
          "Providing one-on-one coaching or mentoring to individuals in leadership roles, helping them navigate challenges & develop their leadership potential in both corporate & non-profit environments.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/score-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/certificate-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/discover-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/education-sephia-filled-icons-pack/attend-class-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r9.jpeg",
  },

  // Certified womens leadership & gender change maker - (Postgrad)
  {
    id: "womens-leadership-gender-postgrad",
    applicationLink: "",
    backgroundImage:
      "/image-fix/academic-programmes/certified-courses/images/bg04.png",
    blurHash: "L,Kd*rt8j?WV~qt7WVoe%MWBayaf",
    title: "Postgraduate Diploma In Womens Leadership & Gender Changemaker",
    duration: "26-32 Weeks Learning Experience",
    qualification: "Postgraduate Diploma in Senior Executive Women Leadership.",
    possibleProgression: "Certified Women Leadership & Gender Changemaker ",
    school: "Faculty of Business &amp; Leadership",
    credits: "60 ECTS",
    studyLevel: "Postgraduate Diploma",
    lengthPrefix: "a",
    programLength: "6 - 8 Months",
    startDate: "October 2026",
    language: "English",

    fees: {
      upfront: 850,
      installment: {
        total: 850,
        perInstallment: 425,
        installments: 2,
      },
    },
    location: "Distance Learning",
    videoLink: "https://www.youtube.com/embed/BgdE65SZ1SU?start=90&autoplay=1&mute=1&controls=1&modestbranding=1&rel=0",
    brochureLink: "",
    actions: ["APPLY NOW", "Download Programme Brochure"],
    overview: {
      intro:
        "Earn a Postgraduate Diploma in Leadership (60 ECTS) with Progression to Master of Arts in Leadership",
      description:
        "The Certified Agile Thought Leader Diploma® Programme is an 8-month, postgraduate-level programme designed for aspiring leaders seeking to advance their careers & develop impactful leadership skills. This Postgraduate Diploma in Leadership awards 60 ECTS credits, recognised globally, & focuses on a competency-based, career-driven approach to leadership development. Upon successful completion, students will earn a Postgraduate Diploma in Leadership & qualify to proceed directly to Stage 2 of the Master of Arts in Leadership programme, receiving exemptions for the modules completed. This transformative programme is ideal for professionals & aspiring leaders aiming to accelerate their career growth, gain practical leadership experience, & pursue advanced academic qualifications in leadership.",
      objectives: [
        `Welcome to The Postgraduate Diploma in Senior Executive Women Leadership Programme which offers a unique opportunity to earn the esteemed Certified Women Leadership & Gender Changemaker designation.

        This comprehensive, 26-32 week Postgraduate Diploma in Senior Executive Women Leadership develops advanced expertise in leadership & gender advocacy, combining rigorous academic study with practical application. 

Designed for women leaders in diverse sectors, the programme fosters transformative leadership, critical thinking, & the ability to implement innovative solutions for promoting gender equity. 

Through a blend of theoretical frameworks, global perspectives, & real-world application, this programme prepares graduates to lead impactful change in their organisations & communities.

Learners will be awarded the prestigious Certified Women Leadership & Gender Changemaker designation upon successfully completing the Postgraduate Diploma in Senior Executive Women
Leadership.`,
      ],
    },

    // Data for the Live Learning Section
    highlights: {
      content: [
        {
          icon: "🌐", // Add appropriate icon
          title: "Live Learning Experience",
          description:
            "Engage in immersive live sessions to enhance your learning experience & interact with peers & instructors in real-time.",
        },
        {
          icon: "👩‍🏫", // Add appropriate icon
          title: "Expert Guest Lecturers",
          description:
            "Learn from leading experts & professionals who bring real-world insights to the classroom.",
        },
        {
          icon: "📚", // Add appropriate icon
          title: "Practical, Real-World Knowledge",
          description:
            "Gain actionable knowledge & hands-on experience to apply directly in your professional environment.",
        },
        {
          icon: "🎓", // Add appropriate icon
          title: "Accredited Certification",
          description:
            "Earn a certification that is globally recognised & validates your skills & knowledge.",
        },
        {
          icon: "🌍", // Add appropriate icon
          title: "Global Networking Opportunities",
          description:
            "Connect with a diverse cohort of professionals & expand your network worldwide.",
        },
        {
          icon: "💻", // Add appropriate icon
          title: "Online Contact Hours with Programme Leader",
          description:
            "Benefit from direct interaction with the programme leader to discuss concepts, clarify doubts, & receive guidance.",
        },
        {
          icon: "✨", // Add appropriate icon
          title: "Eligible for Summer School Programme",
          description:
            "Opportunity to participate in exclusive summer school programmes to further enhance your learning journey.",
        },
      ],
    },

    // To control whether it has model categories or not ( Will be set to true If the modules Has seperate stages or steps or something.)
    moduleCategories: false,

    // Data For the Stucture Section (has module Categories)
    structure: [
      {
        stage: "Stage 1",
        title: "Leadership Fundamentals",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Foundations of Leadership & Emerging Trends",
            credits: 5,
            description:
              "Explore the core principles of leadership & innovative strategies for leading in dynamic environments",
          },
          {
            title: "Communication, Influence, & Collaboration",
            credits: 5,
            description:
              "Master communication techniques, interpersonal skills, & collaboration strategies to foster influence & build effective teams.",
          },
          {
            title: "Strategic Thinking & Decision-Making",
            credits: 5,
            description:
              "Develop strategic planning & visionary thinking skills to solve complex problems & guide organisational success.",
          },
          {
            title: "Emotional Intelligence & Resilience",
            credits: 5,
            description:
              "Cultivate emotional intelligence to manage relationships effectively & build resilience in challenging situations.",
          },
        ],
      },
      {
        stage: "Stage 2",
        title: "Applied Leadership Practices",
        duration: "3 months",
        credits: 20,
        modules: [
          {
            title: "Leadership in the Digital Age",
            credits: 5,
            description:
              "Understand how to lead effectively in a tech-driven world by leveraging digital tools & navigating digital transformation.",
          },
          {
            title: "Change Management & Adaptability",
            credits: 5,
            description:
              "Acquire the skills to lead organisational change, foster innovation, & adapt to rapidly evolving environments",
          },
          {
            title: "Global Perspectives: Leadership & Sustainability",
            credits: 10,
            description:
              "Examine global challenges, including Climate Change & the UN SDGs, & integrate sustainable leadership practices",
          },
        ],
      },
      {
        stage: "Stage 3",
        title: "Leadership Capstone & Career Development",
        duration: "2 months",
        credits: 20,
        modules: [
          {
            title: "Capstone Project: Leadership in Action",
            credits: 15,
            description:
              "Apply your learning to a real-world leadership challenge, create meaningful impact, & present your project at the Leadership Showcase.",
          },
          {
            title: "Employability & Career Development",
            credits: 5,
            description:
              "Develop essential career skills such as personal branding, CV writing, interview techniques, & strategic career planning to enhance your professional growth.",
          },
        ],
      },
    ],

    // Data For the Structure Section (does not have module Categories) - Sample
    stuctureWithoutModelCategories: [
      {
        title: "Foundations of Leadership & Gender Theory",
        description: [
          "Explore leadership theories & their intersection with gender dynamics.",
          "Analyse unconscious biases & barriers to gender equality.",
        ],
      },
      {
        title: "Advanced Leadership & Strategic Thinking",
        description: [
          "Develop strategic decision-making skills for senior leadership roles.",
          "Focus on visionary leadership & change management.",
        ],
      },
      {
        title: "Advocacy, Policy, & Governance",
        description: [
          "Understand policy frameworks & develop skills to influence organisational & public policies.",
          "Study governance models & their impact on gender equality.",
        ],
      },
      {
        title: "Research Methods & Reflective Practice",
        description: [
          "Gain proficiency in qualitative & quantitative research methodologies.",
          "Apply reflective practices to evaluate personal & professional growth.",
        ],
      },
      {
        title: "Entrepreneurship & Economic Empowerment",
        description: [
          "Analyse case studies on women-led enterprises.",
          "Learn financial literacy & strategies for economic independence.",
        ],
      },
      {
        title: "Community Leadership & Social Impact",
        description: [
          "Design & execute community development projects.",
          "Integrate sustainability & social impact principles into leadership practices.",
        ],
      },
      {
        title: "Capstone Project",
        description: [
          "Develop a research-based project addressing a critical gender leadership challenge.",
          "Present findings to peers & mentors, demonstrating mastery of programme concepts.",
        ],
      },
    ],

    // Data For the Admission Section
    // Data For the Admission Section
    admissions: {
      eligibility: [
        {
          title: "Educational Requirements:",
          description:
            "Completed Senior Secondary/Secondary Education with 5 years of work experience.",
        },
        {
          title: "Academic Background:",
          description: "Undergraduate degree (or equivalent).",
        },
        {
          title: "Proficiency in English:",
          description: "Proficiency in English communication.",
        },
      ],
      englishRequirements: [
        "Native English speakers",
        "TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)",
        "IELTS (Minimum score: 5.5)",
        "Cambridge ESOL (CAE, Minimum score: C1)",
        "Proof of English as a language of instruction",
      ],
    },

    // Data For the IT Requirements Section
    itRequirements: [
      {
        icon: "💻",
        description:
          "Access to the internet via a computer, laptop, tablet, or smart device",
      },
      {
        icon: "🎧",
        description:
          "Speakers or headphones to listen to pre-recorded material & videos",
      },
      {
        icon: "🎥",
        description: "A webcam & microphone for interactive sessions",
      },
    ],

    // Data for the Career opportunities Section
    careerOpportunities: [
      {
        icon: "🌟",
        title: "Senior Leadership Roles:",
        description:
          "Upon completion of the programme, you will have the skills to pursue senior leadership roles in corporate, public sector, & nonprofit organisations.",
      },
      {
        icon: "👩‍⚖️",
        title: "Gender Advocacy Specialist:",
        description:
          "Graduates will also be equipped to advocate for gender equality & empower others, positioning themselves as experts in women’s leadership & gender advocacy.",
      },
    ],

    // Data For the Side Attraction Section
    sideAttractions: [
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/touch-click-svgrepo-com.svg",
        title: "Hands-On Leadership Workshops",
        description:
          "Engage in practical exercises that enhance your leadership skills.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/port-detection-svgrepo-com.svg",
        title: "Eligibility for Summer School Programmes in Europe",
        description: "Expand your learning with global academic experiences.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/page-analysis-svgrepo-com.svg",
        title: "Accredited Certification",
        description: "Earn a Certified Agile Thought Leader Diploma.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/machine-vision-svgrepo-com.svg",
        title: "Networking Opportunities",
        description:
          "Build lasting connections with peers, mentors, & global leaders.",
      },
      {
        icon: "/image-fix/career-option-icons/internet-duotone-pack/interface-control-svgrepo-com.svg",
        title: "Pathway to a Degree",
        description:
          "Opportunities to transition into advanced degree programmes.",
      },
    ],

    // The Image on the right side of the side attraction section - ( At the bottom )
    sideAttractionsBgImage: "/image-fix/random-images/r10.jpeg",
  },
];

export default certifiedCourseData;
